const el = {
  common: {
    wallet: "πορτοφόλι",
    playPage: "παίξε",
    minTop: "το ελάχιστο ποσό είναι $10",
    maxTop: "το μέγιστο ποσό είναι $500",
    website: "ιστοσελίδα",
    signOut: "αποσύνδεση",
    hidden: "κρυμμένος",
    victory: "νίκη",
    wentWrong: "κάτι πήγε στραβά, ανακατεύθυνση",
    stakeLabel: "στοίχημα",
    howDoes: "πώς λειτουργεί αυτό;",
    continue: "Συνέχεια",
    continueWithGoogle: "Συνέχεια με Google",
    continueWithApple: "Συνέχεια με Apple",
    termsOfService: "όροι υπηρεσίας",
    privacyPolicy: "πολιτική απορρήτου",
    termsOfServiceFooter: "όροι υπηρεσίας",
    privacyPolicyFooter: "πολιτική απορρήτου",
    verificationCode: "κωδικός επαλήθευσης",
    verify: "επιβεβαίωση",
    account: "λογαριασμός",
    error: "ένα σφάλμα προέκυψε\n",
    checkBackLater: "έλεγξε ξανά αργότερα",
    looking: "ψάχνει...",
    yes: "ναι",
    no: "όχι",
    pleaseSelect: "Παρακαλώ επιλέξτε\n",
    disclaimer: "συνεχίζοντας συμφωνείτε με τους\n",
    and: "και",
  },
  endOfGame: {
    wonByCheckmate: "κέρδισε με σαχ",
    lostOnTime: "έχασε λόγω χρόνου",
    resigns: "παραιτήθηκε",
    gameDrawnByAgreement: "ισοπαλία με συμφωνία",
    abandonedTheGame: "εγκατέλειψε το παιχνίδι",
    gameAborted: "το παιχνίδι ματαιώθηκε",
    gameDrawnByStalemate: "ισοπαλία λόγω πατ",
    gameDrawnByFiftyMoveRule: "ισοπαλία λόγω κανόνα των 50 κινήσεων",
    gameDrawnByInsufficientMaterial: "ισοπαλία λόγω ανεπαρκούς υλικού",
    gameDrawnByThreefoldRepetition: "ισοπαλία λόγω τριπλής επανάληψης",
    draw: "ισοπαλία",
    victory: "νίκη",
    defeat: "ήττα",
    aborted: "ματαιώθηκε",
    white: "άσπρο",
    black: "μαύρο",
    inspectBoard: "προβολή σκακιέρας",
    returnToEndOfGameModal: "συνέχεια",
  },
  byPhone:{
    continueOnPhone: "συνέχεια στο\nκινητό",
    or: "ή",
    continueOnWeb: "συνέχεια στον\nbrowser σας",
    disclaimer: "κατάλληλο αν έχετε μια φωτογραφία της ταυτότητάς σας στον δίσκο"
  },
  signUp: {
    email: "ηλεκτρονικό ταχυδρομείο",
    username: "όνομα χρήστη",
    usernameInvalid: "μη έγκυρο όνομα χρήστη",
    emailInvalid: "μη έγκυρο email",
    login: "σύνδεση",
    continueWithPhone: "συνέχεια με αριθμό τηλεφώνου",
    tickBoxes: "ας τσεκάρουμε μερικά\nκουτιά",
    confirm: "Επιβεβαιώνω ότι\n",
    resideIn: "Διαμένω σε\n",
    notPEP: "Δεν είμαι πολιτικά εκτεθειμένο πρόσωπο (PEP), μέλος οικογένειας ή γνωστός συνεργάτης ενός PEP\n",
    purpose: "Ο σκοπός και η φύση της σχέσης μου με το Gambit είναι αποκλειστικά για να χρησιμοποιήσω την υπηρεσία για διασκέδαση\n",
    soleBenefit: "Θα χρησιμοποιήσω την υπηρεσία αποκλειστικά για το όφελός μου και ότι δεν υπάρχει άλλος ωφελούμενος ιδιοκτήτης\n",
  },
  identity: {
    beingVerified: "η ταυτότητα\nεπαληθεύεται",
    verified: "επαληθευμένη\n",
    failed: "η επαλήθευση\nαπέτυχε",
  },
  payment: {
    failed: "η πληρωμή απέτυχε.\nπαρακαλώ δοκιμάστε ξανά",
    successful: "η πληρωμή\nήταν επιτυχής!",
    toppedUp: "έχετε\nεπαρκές υπόλοιπο!",
    topUp: "ανανέωση\n",
    payWith: "πληρώστε με...\n",
  },
  gameplay: {
    play: "παίξτε\n",
    challenge: "σας προκαλεί σε ένα",
    gameWorth: "παιχνίδι αξίας\n",
    whatsYourNumber: "ποιος είναι ο\nαριθμός σας?",
    receiveCode: "θα λάβετε έναν κωδικό επαλήθευσης\nσύντομα",
    matchedOpponent: "Θα ταιριάξετε με έναν αντίπαλο με παρόμοια βαθμολογία.",
    stake: {
      total: "Το συνολικό στοίχημα θα είναι το ποσό που επιλέγεται παρακάτω.",
      contribution: "Θα συνεισφέρετε περίπου το μισό από αυτό το ποσό.",
      weakerOpponent: "Αν ταιριάξετε με έναν αδύναμο αντίπαλο, θα πληρώσετε μεγαλύτερο μερίδιο του στοιχήματος.",
      strongerOpponent: "Αν ταιριάξετε με έναν ισχυρότερο αντίπαλο, θα πληρώσετε ένα μικρότερο μερίδιο του στοιχήματος.",
    },
    supportInfo: "Επισκεφτείτε την υποστήριξή μας για περισσότερες πληροφορίες.",
    continueBrowser: "συνεχίστε στο\nbrowser σας",
    continuePhone: "συνεχίστε στο\nτηλέφωνο",
    getStarted: "ας ξεκινήσουμε\n",
    sentText: "σας έχουμε στείλει\nένα μήνυμα κειμένου",
    enterReceivedCode: "εισάγετε τον ληφθέν\nκωδικό επαλήθευσης",
    wrongCode: "λάθος κωδικός, δοκιμάστε ξανά\n",
    secPerMove: "δευτ/κίνηση",
    resign: {
      prompt: "είστε σίγουροι ότι θέλετε να παραιτηθείτε;",
    },
    draw: {
      offer: "αποδέχεστε προσφορά ισοπαλίας;",
    },
    rating: "βαθμολογία\n",
    balance: "υπόλοιπο\n",
    rematch: "ρεβάνς\n",
    newOpponent: "νέος αντίπαλος\n",
    home: "σπίτι\n",
    rematchOffer: "ο αντίπαλός σας προσφέρει ρεβάνς. δέχεστε;",
    leaveGame: "Παίζετε ήδη ένα παιχνίδι. Είστε σίγουροι ότι θέλετε να φύγετε;",
    room: "δωμάτιο:\n",
    gameTypes: {
      bullet: {
        title: "σφαίρα\n",
        description: "Σκάκι αδρεναλίνης. Εσείς και ο αντίπαλός σας δίνεστε μόνο 1 λεπτό ο καθένας για να κερδίσετε το παιχνίδι.",
      },
      blitz: {
        title: "φουρτάδα\n",
        description: "Εσείς και ο αντίπαλός σας δίνεστε 3 λεπτά ο καθένας για να κερδίσετε το παιχνίδι.",
      },
    },
    stakes: {
      unlockNext: "παίξτε {amount} περισσότερα παιχνίδια για να ξεκλειδώσετε το επόμενο στοίχημα",
      allUnlocked: "έχετε ξεκλειδώσει όλα τα στοιχήματα",
    },
    withdraw: "ανάληψη\n",
  },
  puzzle: {
    begin: "αρχή",
    next: "επόμενο",
    unavailableInYourRegion: "μη διαθέσιμο",
    puzzle: "παζλ",
    whiteToPlay: "άσπρος για να παίξει",
    blackToPlay: "μαύρος για να παίξει",
    time: "χρόνος",
    solution: "λύση",
    somethingWentWrong: "κάτι πήγε στραβά",
    rating: "αξιολόγηση",
    credits: "πιστώσεις",
    puzzleFailed: "ήττα",
    puzzleSolved: "νίκη",
    correct: "σωστή λύση",
    incorrect: "λάθος λύση",
    youRanOutOfTime: "έληξε ο χρόνος σας",
    puzzleDescription: "Έχετε 10 δευτερόλεπτα + 2 δευτερόλεπτα/κίνηση για να λύσετε ένα παζλ.",
    creditsLeft: "υπολειπόμενες πιστώσεις",
    refillIn: "αναγέμισμα σε",
    lastPuzzle: "Αυτό είναι το τελευταίο σας παζλ, επιστρέψτε αργότερα για περισσότερα.",
    outOfCredits: "Έχετε εξαντλήσει τις πιστώσεις, επιστρέψτε αργότερα.",
    locationPrompt: "Χρειαζόμαστε την τοποθεσία σας για να προχωρήσουμε. Αν είναι αποκλεισμένη, παρακαλώ ενεργοποιήστε την ξανά:",
    locationInstructions: "Κάντε κλικ στο εικονίδιο στη γραμμή διευθύνσεων, επιλέξτε 'Πάντα επιτρέπεται' και ανανεώστε τη σελίδα",
    creditsError: "Σφάλμα κατά την φόρτωση πιστώσεων",
    moves: "Κινήσεις:",
  },
};

export {el};